import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const tablesApi = createApi({
    reducerPath: 'tablesApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getTable: builder.query({
            query: ({ data }) => ({
                url: '/tables/get_table',
                method: 'POST',
                body: { 'data': data }
            }),
        })
    }
    ),
});

export const {
    useGetTableQuery
} = tablesApi;

export default tablesApi.reducer;